'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { useState, useCallback, useEffect } from 'react';
import Button from '../../Button/index.js';
import { showToast } from '../../Toast/index.js';
import { buildCompanyUrl } from '../../Utils/urlBuilder.js';
import { DEFAULT_SUCCESS_CODE, followCompany } from '../apiServices.js';
import { EMPTY_COMPANY_IMAGE } from '../constants.js';
import { CompanyItemWrapper, LogoSection, ContentSection, CompanyDescription, CompanyJobCount, ActionSection } from './CompanyItem.css.js';
import TrustedCompanyName from '../../TrustedCompanyName/index.js';

var CompanyItem = function (props) {
    var companyInfo = props.companyInfo, t = props.t, langCode = props.langCode, accessToken = props.accessToken, msUrl = props.msUrl, isShowFollow = props.isShowFollow, _a = props.classSelector, classSelector = _a === void 0 ? '' : _a;
    var _b = useState((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.isFollowed) === 1 || false), isFollow = _b[0], setFollowed = _b[1];
    var _c = useState((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) || 0), followCount = _c[0], setFollowCount = _c[1];
    var companyUrl = buildCompanyUrl({
        companyId: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId) || 0,
        companySlug: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName,
        langCode: langCode
    });
    var doFollow = useCallback(function (isFollowed) { return __awaiter(void 0, void 0, void 0, function () {
        var apiUrl, response, toastTitle, toastMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (accessToken === null || accessToken === '') {
                        return [2 /*return*/];
                    }
                    if (companyInfo === null || !companyInfo.companyId) {
                        return [2 /*return*/];
                    }
                    apiUrl = "".concat(msUrl, "/api-gateway/v1.0/profile/follow");
                    return [4 /*yield*/, followCompany(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyId, isFollowed, apiUrl, accessToken, langCode)];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== DEFAULT_SUCCESS_CODE) {
                        return [2 /*return*/];
                    }
                    toastTitle = t('Unfollowed');
                    toastMessage = t("You'll stop receive the newest jobs from this company.");
                    if (isFollowed) {
                        toastTitle = t('Yay! Thanks for following');
                        toastMessage = t('You will receive the newest jobs from this company.');
                    }
                    showToast(toastTitle, toastMessage, 'success');
                    return [2 /*return*/];
            }
        });
    }); }, [companyInfo, langCode, t, accessToken, msUrl]);
    var handleOnClickFollow = useCallback(function () {
        var followed = !isFollow;
        doFollow(followed);
        setFollowed(followed);
        setFollowCount(followed ? followCount + 1 : followCount - 1);
    }, [doFollow, followCount, isFollow]);
    useEffect(function () {
        if (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) {
            setFollowCount(companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount);
        }
    }, [companyInfo]);
    return (React__default.createElement(CompanyItemWrapper, { className: "".concat(classSelector, " view_job_item") },
        React__default.createElement(LogoSection, { href: companyUrl },
            React__default.createElement("img", { src: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyLogoURL) || EMPTY_COMPANY_IMAGE, alt: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName })),
        React__default.createElement(ContentSection, { isShowFollow: isShowFollow },
            React__default.createElement(TrustedCompanyName, { name: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) || '', href: companyUrl, isTrusted: (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.profilePublishedSiteMask) === 1, style: { marginBottom: 4 }, tooltip: t('Trusted company') }),
            React__default.createElement(CompanyDescription, null,
                React__default.createElement("span", null,
                    followCount,
                    ' ',
                    companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.followerCount) > 1
                        ? t('followers')
                        : t('follower'))),
            companyInfo && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) && (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 0 ? (React__default.createElement(CompanyJobCount, null, companyInfo === null || companyInfo === void 0 ? void 0 :
                companyInfo.onlineJobCount,
                ' ',
                (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.onlineJobCount) > 1 ? t('opening jobs') : t('opening job'))) : null),
        isShowFollow && (React__default.createElement(ActionSection, null,
            React__default.createElement(Button, { type: 'primary', isOutline: true, size: 'sm', onClick: handleOnClickFollow }, isFollow ? t('Following') : t('Follow'))))));
};

export { CompanyItem as default };
//# sourceMappingURL=index.js.map
